function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24 2C11.324 2 0 10.452 0 22.014C0 26.114 1.476 30.14 4.094 33.264C4.204 36.924 2.048 42.176 0.108 46C5.312 45.06 12.71 42.984 16.064 40.928C34.536 45.422 48 34.118 48 22.014C48 10.39 36.598 2 24 2ZM24 32C22.87 32 21.952 31.082 21.952 29.95C21.952 28.82 22.87 27.902 24 27.902C25.132 27.902 26.048 28.82 26.048 29.95C26.048 31.082 25.132 32 24 32ZM27.212 22.284C25.732 23.882 25.662 24.766 25.68 25.854H22.394C22.382 23.438 22.426 22.37 24.74 20.17C25.678 19.278 26.42 18.572 26.316 17.184C26.222 15.864 25.118 15.176 24.082 15.176C22.92 15.176 21.56 16.04 21.56 18.474H18.268C18.268 14.542 20.578 12 24.15 12C25.848 12 27.334 12.556 28.33 13.566C29.266 14.512 29.748 15.816 29.73 17.332C29.704 19.6 28.322 21.088 27.212 22.284Z",
  fill: "#F6A036"
});

var SvgIconHelp = function SvgIconHelp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_help.36036554.svg";
export { ForwardRef as ReactComponent };